import { useId } from 'react'
import { FIGURES, figureRef, type FigureSpec } from '../../lib/figures'
import { DRAWINGS } from './drawings'
import { HEIGHT, WIDTH } from './kit'

/**
 * One figure, with the sentence that stands in for it.
 *
 * `role="img"` with a `<title>`, which is the opposite of `Icon`'s rule and deliberately so. An icon
 * in this console never carries meaning on its own, so it is hidden; a figure does, so it is named -
 * and the name is the label in `lib/figures.ts`, written as a sentence a screen reader can read in
 * the drawing's place.
 */
export function Figure({ spec }: { spec: FigureSpec }) {
  const { id, focus } = figureRef(spec)
  const titleId = useId()
  const Drawing = DRAWINGS[id]

  return (
    <div className="figure" data-testid={`figure-${id}`}>
      <svg
        className="figure-svg"
        viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
        role="img"
        aria-labelledby={titleId}
        focusable="false"
      >
        <title id={titleId}>{FIGURES[id].label}</title>
        <Drawing focus={focus} />
      </svg>
    </div>
  )
}
